import { create } from "zustand"

export enum ClientListTab {
  CLIENTS = "clients",
  TODOS = "todos",
}

interface ClientListTabStore {
  tab: ClientListTab
  setTab: (tab: ClientListTab) => void
}

const useClientListTabStore = create<ClientListTabStore>((set) => ({
  tab: ClientListTab.CLIENTS,
  setTab: (tab) => set({ tab }),
}))

export default useClientListTabStore
